<template lang="html">
  <footer class="fixed-bottom mobile-nav">
    <mobile-navbar-member v-if="currentUser" />
    <mobile-navbar-guest v-else />

    <div class="svg-container">
      <svg viewBox="0 0 202.9 45.5">
        <clipPath
          id="menu"
          clipPathUnits="objectBoundingBox"
          transform="scale(0.0049285362247413 0.021978021978022)"
        >
          <path
            d="M6.7,45.5c5.7,0.1,14.1-0.4,23.3-4c5.7-2.3,9.9-5,18.1-10.5c10.7-7.1,11.8-9.2,20.6-14.3c5-2.9,9.2-5.2,15.2-7
          c7.1-2.1,13.3-2.3,17.6-2.1c4.2-0.2,10.5,0.1,17.6,2.1c6.1,1.8,10.2,4.1,15.2,7c8.8,5,9.9,7.1,20.6,14.3c8.3,5.5,12.4,8.2,18.1,10.5
          c9.2,3.6,17.6,4.2,23.3,4H6.7z"
          />
        </clipPath>
      </svg>
    </div>
  </footer>
</template>

<script>
import MobileNavbarGuest from "./MobileNavbar/MobileNavbarGuest";
import MobileNavbarMember from "./MobileNavbar/MobileNavbarMember";
import { mapGetters } from "vuex";

export default {
  components: {
    MobileNavbarGuest,
    MobileNavbarMember
  },

  computed: {
    ...mapGetters(["currentUser"])
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.mobile-nav {
  box-sizing: border-box;
  --bgColorMenu: var(--unstitched);
  --duration: 0.7s;

  .svg-container {
    width: 0;
    height: 0;
  }

  @media screen and (max-width: 50em) {
    .menu {
      font-size: 0.8em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/MobileNavbar.vue